const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate optionConformanceBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  if (value === undefined) {
    return undefined;
  }
  const referenceValue = await evaluateSource(source.referenceValue, content, parentContentPath, transientContext, nativeFunctions);
  if (referenceValue === undefined) {
    return undefined;
  }
  const keys = Object.keys(value);
  const referenceKeys = Object.keys(referenceValue);
  if (keys.length === referenceKeys.length && keys.every(key => referenceKeys.includes(key))) {
    return undefined;
  }
  const errorText = await evaluateSource(source.errorText, content, parentContentPath, transientContext, nativeFunctions);
  return errorText;
};
module.exports = {
  evaluate
};